import { useEffect, useRef } from 'react';

export const useUnmountEffect = (cb, deps) => {
    const isComponentUnmountedRef = useRef(false);

    useEffect(() => () => {
        isComponentUnmountedRef.current = true;
    }, []);

    useEffect(() => () => {
        if (isComponentUnmountedRef.current) {
            cb();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
